require("./SummaryPage.less");

const React = require("react");
const T = React.PropTypes;

const PageType = require("~/types/Page.js").PropType;
const SummarySection = require("../SummarySection/SummarySection.jsx");
const SectionOverview = require("../SectionOverview/SectionOverview.jsx");


const SummaryPage = React.createClass({
    PropTypes: {
        SurveyIDPath: T.arrayOf(T.string).isRequired,
        Page: PageType.isRequired,
        IsReadOnly: T.bool.isRequired
    },

    render() {
        const pageIDPath = this.props.SurveyIDPath.concat(this.props.Page.GUID);
        const sections = this.props.Page.Sections
            .sort((q1, q2) => {
                if (q1.DisplayOrder < q2.DisplayOrder) {
                    return -1;
                }

                if (q1.DisplayOrder > q2.DisplayOrder) {
                    return 1;
                }

                return 0;
            })
            .map((s) => {
                return (<SummarySection key={s.GUID} IsReadOnly={this.props.IsReadOnly} Section={s} PageIDPath={pageIDPath } />);
            });

        const sectionOverview = <SectionOverview IsReadOnly={this.props.IsReadOnly} Page={this.props.Page } />

        const sectionsHeader = (<div className="cs-SummaryPage__header">
                                    <div className="cs-SummaryPage__header__table">
                                        <div className="cs-SummaryPage__header__questionCell">Question</div>
                                        <div className="cs-SummaryPage__header__answerCell">Answer</div>
                                        <div className="cs-SummaryPage__header__scoreCell">Score / Possible</div>
                                    </div>
        </div>);
        
        return (<div>
            <div>{sectionOverview}</div>
            <div>{sectionsHeader}</div>
            <div>{sections}</div>
        </div>);
    }
});

module.exports = SummaryPage;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummaryPage/SummaryPage.jsx